<form *ngIf="form" [formGroup]="form">
  <mat-form-field appearance="fill" class="mb-5">
    <mat-label>URL Link</mat-label>
    <input matInput formControlName="urlLink" (blur)="addResource(ResourceType.HTML)" />
  </mat-form-field>
  <mat-form-field appearance="fill" class="mb-5">
    <mat-label>Video Link</mat-label>
    <input matInput formControlName="videoLink" (blur)="addResource(ResourceType.VIDEO_LINK)" />
  </mat-form-field>
  <div class="d-flex flex-column">
    <button
      mat-raised-button
      style="height: 48.35px"
      class="btn btn-light font-weight-normal mb-5"
      (click)="fileInput.click()"
      [disabled]="mode === 'view'"
    >
      Attach PDF
    </button>
    <input #fileInput hidden type="file" accept=".pdf" (change)="uploadFile($event)" />
    <div
      *ngIf="form.get('pdfPath')?.valueChanges | async as path"
      style="padding: 0.75em"
      class="overlay"
    >
      <div class="overlay-wrapper d-flex align-items-center">
        <img src="./assets/media/svg/files/pdf.svg" alt="PDF Icon" style="width: 40px" />
        <div class="ml-2">{{ getFilename(path) }}</div>
      </div>
      <div class="overlay-layer rounded">
        <button
          *ngIf="mode !== 'view'"
          type="button"
          class="btn btn-icon btn-light-danger btn-hover-danger"
          (click)="removeFile($event)"
        >
          <i class="flaticon-delete icon-lg"></i>
        </button>
      </div>
    </div>
  </div>
</form>
